import { render, staticRenderFns } from "./currentApplication.layout.vue?vue&type=template&id=22b4d2d8&scoped=true"
import script from "./currentApplication.layout.vue?vue&type=script&lang=js"
export * from "./currentApplication.layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b4d2d8",
  null
  
)

export default component.exports